import { useState } from "react";
import Button from "react-bootstrap/Button";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { toast, ToastContainer } from "react-toastify";
import { useForgotPasswordMutation } from "../store/api/authSlice";
import { capitalizeFirstLetter } from "../utils/dateAndTimeConversion";

const ForgotPassword = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [visible, setVisible] = useState(false);
  const [formData, setFormData] = useState({
    email: "",
  });

  const [errors, setErrors] = useState({});
  const [forgotPassword, { isLoading }] = useForgotPasswordMutation();

  const validateForm = () => {
    const newErrors = {};
    Object.entries(formData).forEach(([key, value]) => {
      if (!value)
        newErrors[key] = `${capitalizeFirstLetter(
          key.replace("_", " "),
        )} is required`;
    });
    if (formData.email && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.email))
      newErrors.email = "Invalid email format";
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });

    setErrors((prev) => ({
      ...prev,
      [name]: value
        ? ""
        : `${capitalizeFirstLetter(name.replace("_", " "))} is required`,
    }));
  };

  const handleSubmit = async () => {
    if (!validateForm()) return;
    toast.dismiss();
    try {
      const response = await forgotPassword(formData).unwrap();
      if (response.statusCode === 200) {
        toast.success(response.message);
        setVisible(!visible);
      }
    } catch (err) {
      const mesg = err.data?.message || "Something went wrong";
      toast.error(mesg);
    }
  };

  return (
    <>
      <div className="popupBox p-3 p-md-5">
        <ToastContainer />
        <div
          id="forgotPassword"
          style={{ display: visible ? "none" : "block" }}
        >
          <h2 className="text-center fpHd mb-3">Forgot Password?</h2>
          <div className="text-center loginText fpText mb-4">
            Enter your account's associated email for a password reset link.
          </div>
          <ul className="loginForm p-0 m-0">
            <li className="mb-3">
              <input
                type="text"
                placeholder="Email Address*"
                className="formInput"
                name="email"
                value={formData.email}
                onChange={handleChange}
              />
              {errors.email && (
                <span style={{ color: "red" }}>{errors.email}</span>
              )}
            </li>

            <li>
              <Button
                className="loginBtn"
                onClick={handleSubmit}
                disabled={isLoading}
              >
                {isLoading ? (
                  <div className="spinner-border" role="status">
                    <span className="sr-only p-0"></span>
                  </div>
                ) : (
                  "Submit"
                )}
              </Button>
            </li>
          </ul>
        </div>
        <div id="LinkSent" style={{ display: visible ? "block" : "none" }}>
          <h2 className="text-center fpHd mb-3">Link Sent</h2>
          <div className="text-center loginText fpText mb-4">
            Instructions to reset your password has been sent to your registered
            email id.
          </div>
          <div className="text-center mb-4">
            <Button className="smallBtn" onClick={() => setVisible(!visible)}>
              Change Email
            </Button>
          </div>
          <div className="text-center loginText">
            Didn't receive? <a href="#">Resend</a>
          </div>
        </div>
      </div>
    </>
  );
};
export default ForgotPassword;
